import { CLEAR_SINGLE_BANNER, FETCH_SINGLE_BANNER, SET_SINGLE_BANNER } from "../actions";

const initialState = {
    singleBannerData: null,
    isLoading: false,
    error: null,
};

const bannerReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SINGLE_BANNER:
            return { ...state, isLoading: true, error: null };

        case SET_SINGLE_BANNER:
            return { ...state, singleBannerData: action.payload, isLoading: false, error: null };

        case CLEAR_SINGLE_BANNER:
            return { ...state, singleBannerData: null, isLoading: false, error: null };

        default:
            return state;
    }
};

export default bannerReducer;
